// ABDMapi.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

export const initiateAadhaarOtpProcess = async (aadhaarNumber) => {
  try {
    const response = await axios.post(`${BASE_URL}/abdm/initiate-aadhaar-otp`, {
      aadhaarNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error initiating Aadhaar OTP process:', error);
    throw error;
  }
};

export const verifyAadhaarOtp = async (otp, transactionId, mobile) => {
  try {
    const response = await axios.post(`${BASE_URL}/abdm/verify-aadhaar-otp`, {
      otp,
      transactionId,
      mobile
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying Aadhaar OTP:', error);
    throw error;
  }
};

export const initiateMobileOtpProcess = async (mobileNumber, transactionId) => {
  try {
    const response = await axios.post(`${BASE_URL}/abdm/initiate-mobile-otp`, {
      mobileNumber,
      transactionId
    });
    return response.data;
  } catch (error) {
    console.error('Error initiating mobile OTP process:', error);
    throw error;
  }
};

export const verifyMobileOtp = async (otp, transactionId) => {
  try {
    const response = await axios.post(`${BASE_URL}/abdm/verify-mobile-otp`, {
      otp,
      transactionId
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying mobile OTP:', error);
    throw error;
  }
};

export const downloadAbhaCard = async (abhaNumber, xToken) => {
    try {
      const response = await axios.post(`${BASE_URL}/abdm/download-abha-card`, {
        abhaNumber,
        xToken
      }, {
        responseType: 'arraybuffer' // Set the response type to 'arraybuffer' to handle binary data
      });
      return new Blob([response.data], { type: 'image/png' }); // Create a Blob from the response data
    } catch (error) {
      console.error('Error downloading ABHA card:', error);
      throw error;
    }
  };

export const scanHealthFacilityQR = async (requestId, timestamp, acknowledgement, resp) => {
  try {
    const response = await axios.post(`${BASE_URL}/abdm/patients/profile/on-share`, {
      requestId,
      timestamp,
      acknowledgement,
      resp
    });
    return response.data;
  } catch (error) {
    console.error('Error scanning health facility QR code:', error);
    throw error;
  }
};